import { StateSchema } from 'app/config/storeConfig/types';
import { NoteDrawerSchema } from '../types';

export const getNoteDrawerState = (state: StateSchema): NoteDrawerSchema => state.noteDrawer;
